module.exports = __webpack_public_path__ + "img/card_delete_hover.f0aabd3c.svg";